<template>
  <div class="global-footer">
    <div class="footer-content">
      <span>copyright@2025 深圳天翼通国际货运代理公司</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalFooter'
}
</script>

<style scoped>
.global-footer {
  padding: 16px 24px;
  text-align: center;
  background-color: #fff;
  color: #666;
  font-size: 14px;
}

.footer-content {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
